var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioUnmuted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.5C7.5 2.01 9.51 0 12 0C14.49 0 16.5 2.01 16.5 4.5V12C16.5 14.49 14.49 16.5 12 16.5C9.51 16.5 7.5 14.49 7.5 12V4.5ZM12 15C13.65 15 15 13.65 15 12V4.5C15 2.85 13.65 1.5 12 1.5C10.35 1.5 9 2.85 9 4.5V12C9 13.65 10.35 15 12 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.485 12.15C19.5 12.105 19.5 12.045 19.5 12C19.5 11.58 19.17 11.25 18.75 11.25C18.33 11.25 18 11.58 18 12C18 15.315 15.315 18 12 18C8.685 18 6 15.315 6 12C6 11.58 5.67 11.25 5.25 11.25C4.83 11.25 4.5 11.58 4.5 12C4.5 12.045 4.5 12.105 4.515 12.15C4.575 15.96 7.5 19.08 11.25 19.455V22.5H8.25C7.83 22.5 7.5 22.83 7.5 23.25C7.5 23.67 7.83 24 8.25 24H15.75C16.17 24 16.5 23.67 16.5 23.25C16.5 22.83 16.17 22.5 15.75 22.5H12.75V19.455C16.5 19.08 19.425 15.96 19.485 12.15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioUnmuted);
export default __webpack_public_path__ + "static/media/audio-unmuted.cde7d0d6329f4bd764b9a12119efce13.svg";
export { ForwardRef as ReactComponent };